import Listing from '../../purchase-request/Listing';

const CogsListing = () => {
  return <Listing type="cogs" />;
};

export default CogsListing;
